import { Avatar, Box, MediaObject, Paragraph } from '@zillow/constellation-10';
import { IconUserOutline } from '@zillow/constellation-icons';
import { PostReadTime } from '@zillow/zrs-cms';
import React from 'react';

import { PostByLineProps } from './PostByLine.types';

const PostByLine: React.FC<PostByLineProps> = ({ author, readTime, date }) => {
    const publishDateObject = date ? new Date(date) : null;

    return (
        <Box
            css={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 'loose',
            }}
        >
            <MediaObject
                media={
                    <Avatar
                        size="md"
                        src={author?.avatar}
                        alt={author?.name || 'Author'}
                        icon={author?.avatar ? undefined : <IconUserOutline />}
                    />
                }
                css={{ alignItems: 'center' }}
            >
                {!!author?.name && (
                    <Paragraph textStyle="body-sm">{author.name}</Paragraph>
                )}
                {publishDateObject && (
                    <Paragraph textStyle="body-sm">
                        {publishDateObject.toLocaleDateString('en-US', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                        })}
                    </Paragraph>
                )}
            </MediaObject>
            <PostReadTime readTime={readTime} />
        </Box>
    );
};

export default PostByLine;
